import { Center, createStandaloneToast } from "@chakra-ui/react";
import { message } from "components/base";
import { INVALID_ROUTE_OFFLINE_MESSAGE } from "constants/offline";
import { useNetworkMonitor } from "libs/network-monitor/useNetworkMonitor";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";
import { ServiceWorkerStatus, setLoadingNetworkStatus } from "redux/appSlice";
import store, { RootState } from "redux/store";
import { offlineRoutes } from "routes/path";
import AppRoute from "./routes";
import Spinner from "components/ui/Spinner";
import networkMonitor from "libs/network-monitor/NetworkMonitor";

const { toast, ToastContainer } = createStandaloneToast();

export { toast };

function App() {
  const { loadingNetworkStatus, serviceWorkerStatus } = useSelector(
    (state: RootState) => state.app
  );
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isOnline = useNetworkMonitor((state) => state.isOnline);

  useEffect(() => {
    if (loadingNetworkStatus) {
      return;
    }
    if (!isOnline) {
      const isValidRouteOffline = offlineRoutes.some((pathPattern) => {
        return matchPath(pathPattern, pathname);
      });
      if (!isValidRouteOffline) {
        message.warning(INVALID_ROUTE_OFFLINE_MESSAGE);

        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline, pathname, loadingNetworkStatus]);

  useEffect(() => {
    dispatch(setLoadingNetworkStatus(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Disable auto change network to offline if the service worker not installed
    if (serviceWorkerStatus !== ServiceWorkerStatus.READY) return;

    const handleOffline = async () => {
      if (store.getState().app.isShowOfflineMsg && networkMonitor.isOnline()) {
        message.warning(
          "ネットワークの接続が確認できないため、オフラインモードへ移行しました。"
        );
      }
      await networkMonitor.updateStatus(false);
    };

    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, [dispatch, serviceWorkerStatus]);

  if (loadingNetworkStatus) {
    return (
      <Center minH={"100vh"}>
        <Spinner />
      </Center>
    );
  }

  return (
    <>
      <AppRoute />
      <ToastContainer />
    </>
  );
}

export default App;
